import { defineStore } from 'pinia'
import { bounsUsedInfo, getBonusList } from '~/apis/future'
import { div, fix } from '~/utils/math'

export const useBonusStore = defineStore('bonus', {
  state: () => ({
    errorTimes: 0,
    list: [],
    grantsList: [],
    grantsInfo: {},
    bounsUsedInfo: {},
    modal: {
      addMargin: false,
      openAccount: false,
      openBonusList: false,
      openGrantsList: false,
    },
  }),
  getters: {
    isUsedGrants() {
      return this.bounsUsedInfo.usedBonusType === 3
    },
    isUsedBonus() {
      return this.bounsUsedInfo.usedBonusType === 8
    },
    isButtonDisabled() {
      return !this.bounsUsedInfo.usedBonusType || this.errorTimes > 0
    },
  },
  actions: {
    async getBonusList({ pageSize = 100, page = 1, status = 1, type = 8 } = {}) {
      const { success, data } = await getBonusList({ pageSize, page, status, type })
      if (success) {
        this.list = data
      }
    },
    async getaGrantsList({ pageSize = 100, page = 1, status = 1, type = 3 } = {}) {
      const { success, data } = await getBonusList({ pageSize, page, status, type })
      if (success) {
        this.grantsList = data.map((item) => {
          return {
            ...item,
            leverage: Math.floor(div(1, item.marginRate)),
          }
        })
      }
    },
    async getBounsUsedInfo() {
      const { success, data } = await bounsUsedInfo()
      if (success) {
        this.bounsUsedInfo = data
        this.errorTimes = 0
      }
      else {
        this.errorTimes++
        if (this.errorTimes < 5) {
          setTimeout(() => {
            this.getBounsUsedInfo()
          }, 1000)
        }
      }
    },
  },
})
